import template from './rw-privacy-policy-dialog.html';

export default {
  template,
  controller: 'RwPrivacyPolicyDialogController',
  bindings: {
    resolve: '<',
    close: '&',
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/rw-privacy-policy-dialog-component.js